import React from 'react'
import './scroll.scss'

export const Scroll = () => (
	<button className="scroll">
		<span></span>
	</button>
)